exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3IGUY8CBuZNvmRwTiVe_hh{font-size:16px}html[dir=ltr] ._3IGUY8CBuZNvmRwTiVe_hh{padding-left:0}html[dir=rtl] ._3IGUY8CBuZNvmRwTiVe_hh{padding-right:0}", ""]);
// Exports
exports.locals = {
	"star": "_3IGUY8CBuZNvmRwTiVe_hh"
};